// src/pages/ReceivedOrderList.jsx (or similar name)
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    FaFileAlt, // For Pending Review
    FaClock, // For Pending Payment
    FaClipboardCheck, // For Delivered
    FaTasks, // For In Progress
    FaEye,
    FaEdit,
    FaPrint,
    FaAngleLeft,
    FaAngleRight,
} from 'react-icons/fa'; // Importing necessary icons for orders

export default function ReceivedOrderList() {
    const navigate = useNavigate();

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth <= 480);
    const [containerDynamicHeight, setContainerDynamicHeight] = useState('auto');

    // Sample data for received orders
    const [orders, setOrders] = useState([
        { id: '13445', customer: 'Haider zakir', item: '04', amount: 6000, paymentStatus: 'Paid', receivedStatus: 'Delivered' },
        { id: '13446', customer: 'Ali Khan', item: '02', amount: 3500, paymentStatus: 'COD', receivedStatus: 'Failed' },
        { id: '13447', customer: 'Usman Raza', item: '01', amount: 1200, paymentStatus: 'Paid', receivedStatus: 'Delivered' },
        { id: '13448', customer: 'Fatima Bibi', item: '05', amount: 8500, paymentStatus: 'Paid', receivedStatus: 'Delivered' },
        { id: '13449', customer: 'Aisha Malik', item: '03', amount: 4000, paymentStatus: 'COD', receivedStatus: 'Pending' },
        { id: '13450', customer: 'Ahmed Sohail', item: '01', amount: 2000, paymentStatus: 'Paid', receivedStatus: 'Delivered' },
    ]);

    useEffect(() => {
        const handleResize = () => {
            const currentWidth = window.innerWidth;
            const currentHeight = window.innerHeight;

            setIsMobile(currentWidth <= 768);
            setIsSmallMobile(currentWidth <= 480);

            const calculatedHeight = currentHeight - (isMobile ? 40 : 80);
            setContainerDynamicHeight(Math.max(calculatedHeight, 600));
        };

        window.addEventListener('resize', handleResize);
        handleResize(); // Call once initially to set the correct size
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isMobile]);

    const handleViewOrder = (orderId) => {
        console.log('Viewing Order ID:', orderId);
        // navigate(`/order-details/${orderId}`); // Example navigation
    };

    const handleEditOrder = (orderId) => {
        console.log('Edit Order:', orderId);
    };

    const handlePrintOrder = (orderId) => {
        console.log('Print Order:', orderId);
    };

    const styles = {
        mainWrapper: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            width: '100%',
            backgroundColor: 'transparent', // Same background as InvoiceList
            padding: isSmallMobile ? '0px' : (isMobile ? '15px' : '20px'),
            boxSizing: 'border-box',
            fontFamily: 'Inter, sans-serif',
            overflow: 'hidden',
        },
        orderListPageContainer: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            maxWidth: '1200px',
            height: containerDynamicHeight,
            backgroundColor: '#E5D0A5', // Main container background
            borderRadius: '10px',
            overflowY: 'auto',
            padding: isSmallMobile ? '15px' : '20px',
            boxSizing: 'border-box',
        },
        headerTitle: {
            fontSize: isSmallMobile ? '20px' : (isMobile ? '24px' : '30px'),
            color: '#000', // Dark text for titles
            marginBottom: isSmallMobile ? '15px' : '20px',
            fontWeight: 'bold',
            textAlign: 'left',
        },
        cardsContainer: {
            display: 'grid',
            gridTemplateColumns: isSmallMobile ? '1fr' : (isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)'),
            gap: isSmallMobile ? '10px' : '15px',
            marginBottom: isSmallMobile ? '15px' : '20px',
        },
        card: {
            backgroundColor: '#000', // Black background for cards
            borderRadius: '8px',
            padding: isSmallMobile ? '8px' : '12px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            color: '#E5D0A5', // Light text for cards
            minHeight: isSmallMobile ? '70px' : '90px',
        },
        cardHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '3px',
        },
        cardTitle: {
            fontSize: isSmallMobile ? '12px' : '14px',
            margin: 0,
        },
        cardIcon: {
            fontSize: isSmallMobile ? '16px' : '20px',
            color: '#E5D0A5', // Light icon color
        },
        cardValue: {
            fontSize: isSmallMobile ? '18px' : '24px',
            fontWeight: 'bold',
            textAlign: 'right',
        },
        receivedOrderContainer: {
            backgroundColor: '#000', // Black background for the table section
            borderRadius: '10px',
            padding: isSmallMobile ? '15px' : '20px',
            color: '#E5D0A5', // Light text for this section
        },
        receivedOrderHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '15px',
            flexDirection: isSmallMobile ? 'column' : 'row',
            gap: isSmallMobile ? '10px' : '0',
            textAlign: isSmallMobile ? 'center' : 'left',
        },
        receivedOrderTitle: {
            fontSize: isSmallMobile ? '16px' : '20px',
            margin: 0,
            fontWeight: 'bold',
        },
        exportButton: {
            backgroundColor: '#E5D0A5', // Light background for Export button
            color: '#000', // Dark text for Export button
            border: 'none',
            borderRadius: '5px',
            padding: '8px 15px',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: 'bold',
            transition: 'background-color 0.2s ease',
        },
        exportButtonHover: {
            backgroundColor: '#d0b98e', // Slightly darker hover for Export button
        },
        tableWrapper: {
            overflowX: 'auto',
            marginBottom: '15px',
            '::-webkit-scrollbar': {
                display: 'none'
            },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            minWidth: isMobile ? '700px' : '850px',
        },
        tableHeader: {
            backgroundColor: '#000', // Table header background (same as container)
            color: '#E5D0A5', // Light text for header
            fontSize: '12px',
            textAlign: 'left',
            padding: '8px 0',
            borderBottom: '1px solid #333', // Subtle border
        },
        th: {
            // Increased padding for header cells
            padding: '16px 10px', // Increased top/bottom padding
            whiteSpace: 'nowrap',
        },
        tableRow: {
            borderBottom: '1px solid #333', // Subtle border between rows
        },
        tableRowHover: {
            backgroundColor: '#1a1a1a', // Darker on hover
        },
        td: {
            // Increased padding for table data cells
            padding: '16px 10px', // Increased top/bottom padding
            verticalAlign: 'middle',
            whiteSpace: 'nowrap',
            fontSize: '12px',
        },
        statusPill: {
            display: 'inline-block',
            padding: '4px 8px',
            borderRadius: '5px',
            fontSize: '10px',
            fontWeight: 'bold',
            textAlign: 'center',
            color: '#000', // Dark text for status pills
        },
        statusPillPaid: {
            backgroundColor: '#38A169', // Green for Paid/Delivered
            color: '#FFF',
        },
        statusPillCOD: {
            backgroundColor: '#FFC107', // Orange/Yellow for COD/Pending
            color: '#000',
        },
        statusPillFailed: {
            backgroundColor: '#DC3545', // Red for Failed
            color: '#FFF',
        },
        actionButtons: {
            display: 'flex',
            gap: '4px',
            justifyContent: 'center',
        },
        actionButton: {
            backgroundColor: '#E5D0A5', // Light background for action buttons
            border: 'none',
            borderRadius: '5px',
            padding: '5px 7px',
            cursor: 'pointer',
            fontSize: '12px',
            color: '#000', // Dark text/icon for action buttons
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background-color 0.2s ease',
        },
        actionButtonHover: {
            backgroundColor: '#d0b98e', // Slightly darker hover
        },
        actionButtonIcon: {
            fontSize: '13px',
        },
        paginationContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '15px',
            flexDirection: isSmallMobile ? 'column' : 'row',
            gap: isSmallMobile ? '10px' : '0',
            padding: '0 5px',
        },
        paginationControls: {
            display: 'flex',
            gap: '4px',
            flexWrap: 'wrap',
            justifyContent: isSmallMobile ? 'center' : 'flex-start',
        },
        paginationButton: {
            backgroundColor: '#E5D0A5', // Light background for pagination buttons
            color: '#000', // Dark text for pagination buttons
            border: '1px solid #000', // Dark border
            borderRadius: '5px',
            padding: '4px 8px',
            cursor: 'pointer',
            fontSize: '12px',
            transition: 'background-color 0.2s ease',
            minWidth: '25px',
            textAlign: 'center',
        },
        paginationButtonActive: {
            backgroundColor: '#000', // Black background for active pagination button
            color: '#E5D0A5', // Light text for active pagination button
        },
        paginationButtonHover: {
            backgroundColor: '#d0b98e', // Hover for pagination buttons
        },
        paginationText: {
            color: '#E5D0A5', // Light text for pagination result count
            fontSize: '12px',
            marginTop: isSmallMobile ? '8px' : '0',
        },
    };

    // Pagination logic (simplified, assuming all orders shown for now)
    const totalResults = orders.length; // You would replace this with actual total count from API

    return (
        <div style={styles.mainWrapper}>
            <div style={styles.orderListPageContainer}>
                <h1 style={styles.headerTitle}>Received Order</h1>

                {/* Top Cards Section */}
                <div style={styles.cardsContainer}>
                    <div style={styles.card}>
                        <div style={styles.cardHeader}>
                            <h3 style={styles.cardTitle}>Pending Review</h3>
                            <FaFileAlt style={styles.cardIcon} />
                        </div>
                        <p style={styles.cardValue}>490</p>
                    </div>

                    <div style={styles.card}>
                        <div style={styles.cardHeader}>
                            <h3 style={styles.cardTitle}>Pending Payment</h3>
                            <FaClock style={styles.cardIcon} />
                        </div>
                        <p style={styles.cardValue}>490</p>
                    </div>

                    <div style={styles.card}>
                        <div style={styles.cardHeader}>
                            <h3 style={styles.cardTitle}>Delivered</h3>
                            <FaClipboardCheck style={styles.cardIcon} />
                        </div>
                        <p style={styles.cardValue}>490</p>
                    </div>

                    <div style={styles.card}>
                        <div style={styles.cardHeader}>
                            <h3 style={styles.cardTitle}>In Progress</h3>
                            <FaTasks style={styles.cardIcon} />
                        </div>
                        <p style={styles.cardValue}>490</p>
                    </div>
                </div>

                {/* All Received Order Section */}
                <div style={styles.receivedOrderContainer}>
                    <div style={styles.receivedOrderHeader}>
                        <h2 style={styles.receivedOrderTitle}>All Received Order</h2>
                        <button
                            style={styles.exportButton}
                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.exportButtonHover.backgroundColor}
                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.exportButton.backgroundColor}
                        >
                            Export
                        </button>
                    </div>

                    <div style={styles.tableWrapper}>
                        <table style={styles.table}>
                            <thead style={styles.tableHeader}>
                                <tr>
                                    <th style={styles.th}>Order ID</th>
                                    <th style={styles.th}>Customer</th>
                                    <th style={styles.th}>Item</th>
                                    <th style={styles.th}>Amount</th>
                                    <th style={styles.th}>Payment Status</th>
                                    <th style={styles.th}>Received Status</th>
                                    <th style={styles.th}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders.map((order, index) => (
                                    <tr
                                        key={order.id}
                                        style={styles.tableRow}
                                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.tableRowHover.backgroundColor}
                                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                    >
                                        <td style={styles.td}>#{order.id}</td>
                                        <td style={styles.td}>{order.customer}</td>
                                        <td style={styles.td}>{order.item}</td>
                                        <td style={styles.td}>{order.amount}</td>
                                        <td style={styles.td}>
                                            <span style={{
                                                ...styles.statusPill,
                                                ...(order.paymentStatus === 'Paid' ? styles.statusPillPaid : styles.statusPillCOD)
                                            }}>
                                                {order.paymentStatus}
                                            </span>
                                        </td>
                                        <td style={styles.td}>
                                            <span style={{
                                                ...styles.statusPill,
                                                ...(order.receivedStatus === 'Delivered' ? styles.statusPillPaid :
                                                    order.receivedStatus === 'Failed' ? styles.statusPillFailed :
                                                        styles.statusPillCOD) // For Pending status
                                            }}>
                                                {order.receivedStatus}
                                            </span>
                                        </td>
                                        <td style={styles.td}>
                                            <div style={styles.actionButtons}>
                                                <button
                                                    style={styles.actionButton}
                                                    onClick={() => handleViewOrder(order.id)}
                                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.actionButtonHover.backgroundColor}
                                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.actionButton.backgroundColor}
                                                >
                                                    <FaEye style={styles.actionButtonIcon} />
                                                </button>
                                                <button
                                                    style={styles.actionButton}
                                                    onClick={() => handleEditOrder(order.id)}
                                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.actionButtonHover.backgroundColor}
                                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.actionButton.backgroundColor}
                                                >
                                                    <FaEdit style={styles.actionButtonIcon} />
                                                </button>
                                                <button
                                                    style={styles.actionButton}
                                                    onClick={() => handlePrintOrder(order.id)}
                                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.actionButtonHover.backgroundColor}
                                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.actionButton.backgroundColor}
                                                >
                                                    <FaPrint style={styles.actionButtonIcon} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination - Simplified for now, similar to your previous component */}
                    <div style={styles.paginationContainer}>
                        <div style={styles.paginationControls}>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                <FaAngleLeft />
                            </button>
                            <button
                                style={{ ...styles.paginationButton, ...styles.paginationButtonActive }}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonActive.backgroundColor}
                            >
                                1
                            </button>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                2
                            </button>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                3
                            </button>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                4
                            </button>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                5
                            </button>
                            <span style={styles.paginationText}> ...... </span>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                10
                            </button>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                <FaAngleRight />
                            </button>
                        </div>
                        <p style={styles.paginationText}>{totalResults} Results</p>
                    </div>
                </div>
            </div>
        </div>
    );
}